import { useState } from "react";
import "./Departments.css";

const data = {
  org: "Zilla Parishad Pune",
  title: "Secondary Education Department",
  titleMarathi: "माध्यमिक शिक्षण विभाग",
  established: "Pune Zilla Parishad",
  emblem: "🎓",
  intro: `The Education Department (Secondary), Zilla Parishad Pune works under the School Education Department of the Maharashtra Government. It manages all government approved secondary schools in the district including Aided, Unaided, Permanently Unaided, and Self-financed schools across various mediums. Schools cover Std. 5th to 10th, 5th to 12th, 8th to 10th, and 8th to 12th grades. The Education Officer (Secondary) acts as head of both the Pay Unit and Education Department, overseeing all schemes and ensuring benefits reach students through subordinate officers and employees.`,
  stats: [
    { value: "Std 5–12", label: "Grades Covered" },
    { value: "4", label: "School Categories" },
    { value: "₹1,000/mo", label: "NMMSS Scholarship" },
    { value: "₹10,000", label: "INSPIRE Award Amount" },
    { value: "2", label: "NTS Exam Stages" },
    { value: "6", label: "Science Exhibition Groups" },
  ],
  info: [
    { key: "Organization", val: "Zilla Parishad Pune" },
    { key: "Under Dept.", val: "School Education, Maharashtra" },
    { key: "Head", val: "Education Officer (Secondary)" },
    { key: "School Types", val: "Aided, Unaided, Self-financed" },
    { key: "Grades", val: "Std. 5 to 12" },
    { key: "Telephone", val: "020-26050733" },
    { key: "Address", val: "District Level Office" },
  ],
  contact: [
    { icon: "📞", label: "020-26050733" },
    { icon: "🏢", label: "District Level Office" },
    { icon: "🏛️", label: "Zilla Parishad Pune" },
  ],
  services: [
    "Teacher Salary Disbursement",
    "Post Fixation",
    "Staff Provident Fund",
    "Medical Bills Processing",
    "School Inspections",
    "Student Quality Assessment",
    "Scholarship Management",
    "Science Exhibition Coordination",
  ],
  schemes: [
    {
      name: "National Means-Cum-Merit Scholarship (NMMSS)",
      desc: "Centrally sponsored scheme since 2007-08. Eligible Grade 8 students appear for state-level exam by Maharashtra State Council of Examinations. Selected students receive ₹1,000/month (₹12,000/year) up to Grade 12. Applies to government, local body and private aided schools. Parent annual income must not exceed ₹3,50,000.",
      amount: "₹12,000/year (Grades 9–12)",
    },
    {
      name: "National Talent Search Exam (NTS)",
      desc: "Central Government scheme for Grade 10 students. Conducted in two stages — state level and central level — by Maharashtra State Council of Examinations, Pune. Talented students selected through this exam receive scholarships for higher education. Eligible for government-recognized aided secondary school students.",
      amount: "Scholarship up to Higher Education",
    },
    {
      name: "Science Exhibition",
      desc: "Organized annually at taluka and district levels under State Institute of Science Education, Nagpur. Aims to develop scientific perspective, observation skills and experimental proficiency. Students from Grades 6–12 divided into six groups can participate. District-level winners proceed to state level. NCERT provides annual primary themes.",
      amount: "Grades 6–12 | Taluka → State Level",
    },
    {
      name: "INSPIRE Award MANAK",
      desc: "Implemented since 2009-10 by Dept. of Science & Technology, Govt. of India. Enhances creativity and innovation among students. School registration and student nominations done by Headmasters on E-MIAS web portal. Selected students receive ₹10,000 via Direct Benefit Transfer to develop innovative projects. District winners proceed to state and national exhibitions.",
      amount: "₹10,000 per student (Grades 6–10)",
    },
  ],
  faqs: [
    {
      q: "Can institutions recruit teachers directly instead of using the Pavitra Portal?",
      a: "Except for minority institutions, other institutions cannot recruit teachers directly without using the Pavitra Portal.",
    },
    {
      q: "How should vacant clerical positions be filled?",
      a: "After adjustments from surplus to deficit based on approval, further action will be taken to fill vacant positions as per government orders.",
    },
    {
      q: "What is the required land area to start a self-financed new school?",
      a: "1 acre of land is required.",
    },
    {
      q: "Through which office is personal approval given for junior college employees?",
      a: "The Deputy Director of Education Office, Pune Division, Pune.",
    },
    {
      q: "Is in-service training required for senior pay scale promotions?",
      a: "No, it is not required.",
    },
    {
      q: "Is it necessary for eligible teachers to receive the senior grade before selection grade?",
      a: "Yes, it is necessary.",
    },
    {
      q: "What documents are needed for changing a student's caste?",
      a: "Caste certificate, caste validity certificate, parent's affidavit, Form 3.",
    },
    {
      q: "What documents are required for changing a student's name?",
      a: "Birth certificate, gazette notification, parent's affidavit, ration card, Forms 1 and 2.",
    },
    {
      q: "How to submit nominations under the Inspire Award Scheme?",
      a: "Register the school on the E-MIAS web portal of the Dept. of Science & Technology, Govt. of India, then register student nominations.",
    },
  ],
  tabs: ["Overview", "Schemes", "FAQs", "Services", "Contact"],
};

export default function SecondaryEducationVibhag() {
  const [activeTab, setActiveTab] = useState("Overview");
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div>
      {/* Top Strip */}
      <div className="dept-top-strip">
        <span>🎓 Zilla Parishad Pune — Secondary Education Department</span>
        <span>📞 020-26050733</span>
      </div>

      {/* Header */}
      <div className="dept-header">
        <div className="dept-header-emblem">{data.emblem}</div>
        <div className="dept-header-text">
          <div className="dept-header-org">{data.org}</div>
          <div className="dept-header-title">{data.title}</div>
          <div className="dept-header-subtitle">{data.titleMarathi}</div>
        </div>
        <div className="dept-header-badge">School Education Dept.</div>
      </div>

      {/* Nav Tabs */}
      <div className="dept-nav">
        {data.tabs.map((tab) => (
          <button
            key={tab}
            className={`dept-nav-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="dept-main">

        {/* Intro Hero */}
        <div className="dept-intro">
          <div className="dept-intro-label">About the Department</div>
          <div className="dept-intro-text">{data.intro}</div>
        </div>

        {/* Stats Row */}
        <div className="dept-stats">
          {data.stats.map((s, i) => (
            <div className="dept-stat-card" key={i}>
              <div className="dept-stat-value">{s.value}</div>
              <div className="dept-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Schemes + FAQs Column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>

          {/* Schemes */}
          <div className="dept-section">
            <div className="dept-section-header">
              <div className="dept-section-icon">📋</div>
              <div className="dept-section-title">Government Schemes</div>
            </div>
            <div className="scheme-list">
              {data.schemes.map((scheme, i) => (
                <div className="scheme-card" key={i}>
                  <div className="scheme-card-name">{scheme.name}</div>
                  <div className="scheme-card-desc">{scheme.desc}</div>
                  <span className="scheme-card-amount">{scheme.amount}</span>
                </div>
              ))}
            </div>
          </div>

          {/* FAQs */}
          <div className="dept-section">
            <div className="dept-section-header">
              <div className="dept-section-icon">❓</div>
              <div className="dept-section-title">Frequently Asked Questions</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {data.faqs.map((faq, i) => (
                <div
                  key={i}
                  style={{
                    border: "1px solid var(--border)",
                    borderRadius: "var(--radius-sm)",
                    overflow: "hidden",
                  }}
                >
                  <div
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    style={{
                      padding: "14px 18px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      background: openFaq === i ? "var(--saffron-light)" : "var(--off-white)",
                      fontWeight: "600",
                      fontSize: "0.88rem",
                      color: "var(--navy)",
                      gap: "12px",
                    }}
                  >
                    <span>{faq.q}</span>
                    <span style={{ flexShrink: 0, color: "var(--saffron)", fontSize: "1rem" }}>
                      {openFaq === i ? "▲" : "▼"}
                    </span>
                  </div>
                  {openFaq === i && (
                    <div
                      style={{
                        padding: "12px 18px 16px",
                        fontSize: "0.84rem",
                        color: "var(--text-mid)",
                        lineHeight: "1.6",
                        borderTop: "1px solid var(--border)",
                        background: "#fff",
                      }}
                    >
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* Sidebar */}
        <div className="dept-sidebar">

          {/* Department Info */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Department Details</div>
            {data.info.map((row, i) => (
              <div className="dept-info-row" key={i}>
                <span className="dept-info-key">{row.key}</span>
                <span className="dept-info-val">{row.val}</span>
              </div>
            ))}
          </div>

          {/* Services */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Key Services</div>
            <div className="dept-services-grid">
              {data.services.map((s, i) => (
                <div className="dept-service-item" key={i}>{s}</div>
              ))}
            </div>
          </div>

          {/* Highlight Box */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Digital Initiatives</div>
            <div className="dept-highlight-box">
              <div className="dept-highlight-box-title">💻 Tech-Enabled Administration</div>
              <p>
                Department work is facilitated through computer assistance. Circulars, GRs, scheme info, staff fixation, provident fund, and medical bills are all processed digitally via the official website.
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="dept-contact-card">
            <div className="dept-contact-card-title">Contact Information</div>
            {data.contact.map((c, i) => (
              <div className="dept-contact-row" key={i}>
                <span>{c.icon}</span>
                <span>{c.label}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Footer */}
      <div className="dept-footer">
        <strong>Zilla Parishad Pune</strong> — Secondary Education Department &nbsp;|&nbsp; Telephone: 020-26050733 &nbsp;|&nbsp; District Level Office
      </div>
    </div>
  );
}
